// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Layout__Wrapper__e2Bq","Root":"Layout__Root_1jh3C","SocialLinks":"Layout__SocialLinks_2W24R"};